// extracted by mini-css-extract-plugin
export default {"floatingActionButtonContainer":"ktndJ","iOSSafeAreaContainer":"mYJKa","floatingActionButton":"IEAHW"};